import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground" data-testid="app-layout">
      <Navbar />
      <main className="flex-1 pt-[72px]" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
